import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import Button from '@/components/global/Button';
import Icon from '@/components/global/Icon';

import styles from './SearchBox.module.scss';

interface Props {
  state: any;
  disabled?: boolean;
  onSearch?: ({ value }) => void;
  hasSeparator?: boolean;
}

const SearchBox: React.FC<Props> = ({ state, disabled, onSearch, hasSeparator = true }) => {
  const [search, setSearch] = state;
  const [changed, setChanged] = useState<boolean>(null);

  useEffect(() => {
    if (changed) {
      const timer = setTimeout(() => {
        setChanged(false);
        onSearch({ value: search });
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [search, changed]);

  const clear = () => {
    setSearch('');
    onSearch({ value: '' });
    setChanged(true);
  };

  return (
    <div className={clsx(styles.search, disabled && styles.disabled)}>
      <div className={clsx({ [styles.icon]: hasSeparator })}>
        <Icon width="16" height="16" iconName="search" />
      </div>
      <input
        placeholder="Search by family name"
        className={styles.input}
        value={search}
        onChange={(ev) => {
          setSearch(ev.target.value);
          setChanged(true);
        }}
        disabled={disabled}
        aria-label="Search"
      />
      {search && (
        <Button callBack={clear} variant="ghost" title="clear search">
          <Icon width="16" height="16" iconName="close" />
        </Button>
      )}
    </div>
  );
};

export default SearchBox;
